export default "__VITE_ASSET__k_RgzAB3__"